import styles from './Footer.module.css';

function Footer() {
  return (
    <footer className="pb-5">
      <h4 className={styles.heading}>Important information &amp; risk disclosure</h4>
      <p className={`${styles.body} mt-2 mb-4`}>
        The performance figures displayed are illustrative estimates and should not be interpreted as
        guarantees or promises of future returns. Calculations assume a $100,000 trading account and a
        one-time, non-refundable $7,000 activation fee, with returns expressed as estimated first-year net
        ROI after deducting the activation fee. Actual performance will vary based on market conditions,
        strategy execution, and account performance. Trading leveraged financial instruments involves
        significant risk and may result in losses. Only risk capital you can afford to.
      </p>
      <nav className="d-flex align-items-center justify-content-center justify-content-md-end gap-3">
        <a
          href="https://www.team-pow.com/pow-terms-conditions"
          className={styles.link}
          target="_blank"
          rel="noopener noreferrer"
        >
          Terms
        </a>
        <span className={styles.separator} aria-hidden="true">•</span>
        <a
          href="https://www.team-pow.com/pow-privacy-policy"
          className={styles.link}
          target="_blank"
          rel="noopener noreferrer"
        >
          Privacy
        </a>
      </nav>
    </footer>
  );
}

export default Footer;
